import React, { useEffect } from 'react';
import mindmaster_logo from '../data/mindmaster_logo.png';
import { useStateContext } from '../contexts/ContextProvider';
import { ColumnLinks, ColumnTitle, FooterColumn, FooterHref, FooterLeft, FooterLogo, FooterRight, FooterWaxDAOText } from './LeftDiv';
import { currentWebsiteURL } from '../data/config';
import { FooterCont } from '../data/css/FooterStyles';


const Footer = () => {
  const { 


  } = useStateContext();


  return (
    <FooterCont>
   
    &copy; WaxDAO Names 2023

    </FooterCont>
  )
}

export default Footer